module.exports = __webpack_public_path__ + "img/p29188.8cea89af.jpg";